import React, { createContext, useContext, useReducer } from 'react';

import { MeetingsStateContext, MeetingsStoreProviderProps } from './types';
import { meetingStoreReducer } from './reducer';
import { initinalState } from './initialState';

const MeetingsStoreContext = createContext<MeetingsStateContext>({
	state: initinalState,
	dispatch: null,
});

const useMeetingsStoreContext = (): MeetingsStateContext => useContext(MeetingsStoreContext);

function MeetingsStoreProvider(props: MeetingsStoreProviderProps): JSX.Element {
	const [state, dispatch] = useReducer(meetingStoreReducer, initinalState);

	return (
		<MeetingsStoreContext.Provider value={{ state, dispatch }}>
			{props.children}
		</MeetingsStoreContext.Provider>
	);
}

export {MeetingsStoreProvider, useMeetingsStoreContext, initinalState as meetingStoreInitialState};
